(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/play-util.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/play-util.js');
"use strict";


const couponValues = svs.racing.common.constants.couponValues;
const systemTypes = svs.racing.common.constants.systemTypes;
const raceOpen = svs.racing.common.statusUtil.raceOpen;
const couponValueToText = value => {
  switch (value) {
    case couponValues.CANCELED:
      return '';
    default:
      return value;
  }
};
const getCouponItemSystemClass = (systemType, race) => {
  if (systemType === systemTypes.TOP_RANK && !raceOpen(race)) {
    return 'coupon-system-mode-not-open';
  }
  switch (systemType) {
    case systemTypes.TOP_RANK:
    case systemTypes.TOP_RANK_PIX:
      return 'coupon-system-mode';
    case systemTypes.UNIT_COMBINED:
    case systemTypes.UNIT_COMBINED_UNORDERED:
    case systemTypes.WHEEL:
    default:
      return 'coupon-regular-mode';
  }
};
const formatCurrency = num => {
  const str = num.toString();
  const reverseStr = str.split('').reverse().join('');
  const spacedStr = reverseStr.replace(/(\d{3})/g, '$1 ').replace(/(^\s+|\s+$)/, '');
  return "".concat(spacedStr.split('').reverse().join(''), " kr");
};
svs.racing_game.components.play.Util = {
  couponValueToText,
  formatCurrency,
  getCouponItemSystemClass
};

 })(window);